<template lang="pug">
  div(:class="themeClass")
    .pagination
      select(v-if="availablePerPage" @change="selectPerPage")
        option(
          v-for="perPage in perPages"
          :value="perPage.code"
          :selected="Number(perPage.code) === pagination.currentPerPage") {{ perPage.name }}

      ul.page-list(:class="{ 'page-list-upside': listUpside }")
        li.page-item
          a.page-link(v-if="pagination.prevPage !== null" @click="selectPage(pagination.prevPage)")
            span &laquo;
            span.sr-only &laquo;
          span.page-link(v-if="pagination.prevPage === null")
            span &laquo;
            span.sr-only &laquo;

        template(v-for="block in pages")
          li.page-item(v-for="page in block"
            v-bind:class="{ active: page === pagination.currentPage }")
            a.page-link(@click="selectPage(page)") {{ page }}
          li.page-item(v-if="block !== last(pages)")
            span &hellip;

        li.page-item
          a.page-link(v-if="pagination.nextPage !== null" @click="selectPage(pagination.nextPage)")
            span &raquo;
            span.sr-only &raquo;
          span.page-link(v-if="pagination.nextPage === null")
            span &raquo;
            span.sr-only &raquo;
</template>

<script>
  import { perPages } from '../../constants'
  import { generatePageList } from './Pagination.lib'
  import { last } from '../../libs/collection-utility'

  const helpers = { last }

  export default {
    props: {
      pagination: {
        type: Object,
        required: true,
      },
      availablePerPage: {
        type: Boolean,
        default: true,
      },
      listUpside: {
        type: Boolean,
        default: false,
      },
    },
    beforeCreate () {
      this.perPages = perPages
    },
    computed: {
      pages () {
        return generatePageList({ pagination: this.pagination, blockSize: 3 })
      },
      themeClass () {
        if (location.hostname.includes('mynavi')) return 'theme-mynavi'
      },
    },
    methods: {
      selectPerPage (e) {
        this.$emit('selectPerPage', e.currentTarget.value)
      },
      selectPage (page) {
        this.$emit('selectPage', page)
      },
      ...helpers,
    },
  }
</script>



// WEBPACK FOOTER //
// src/components/parts/Pagination.vue